import { MessagingBridgeManagerMasterContextProvider } from "../../../contexts/messagingBridgeManagerProvider";
import { useSettings } from "../../../hooks/settings";
import RouteContainer, { RouteContainerProps } from "./RouteContainer";

export const MasterRouteContainer = ({ element, children }: RouteContainerProps) => {
  const [settings] = useSettings();
  return (
    <MessagingBridgeManagerMasterContextProvider
      options={{
        enableBroadcast: settings.bridge?.master?.enableBroadcast ?? false,
        password: settings.secret?.localPassword ?? undefined,
      }}
    >
      <RouteContainer element={element} children={children} />
    </MessagingBridgeManagerMasterContextProvider>
  );
};

export default MasterRouteContainer;
